import { type DisplayInvoiceAddress } from '~/types/Address';

export const SHIPPO_US_ADDRESS: DisplayInvoiceAddress = {
  city: 'San Francisco',
  company: 'Popout, Inc.',
  country: 'United States',
  email: 'noreply@shippo.com',
  state: 'CA',
  street1: '2261 Market Street',
  street2: 'Suite 5603',
  zip: '94114',
};

export const SHIPPO_DE_ADDRESS: DisplayInvoiceAddress = {
  city: 'Schnaittach',
  company: 'Shippo UG (haftungsbeschraenkt)',
  country: 'Germany',
  email: 'noreply@shippo.com',
  street1: 'Nuernberger Str. 91',
  zip: '91220',
};
